<script setup>
import { formatPrice } from '../../../../Greativ/helper/price'
import { checkPartner } from '../stores/partner'
import { computed, onMounted, onUnmounted, ref } from 'vue'

const currency = window.settings.shop.currency

const isLoggedIn = ref(false)
const creditLeft = ref(0)
const usedCreditInBasket = ref(0)

const showNotification = computed(() => {
  return !!(isLoggedIn.value && creditLeft.value)
})

let currentCheckTimeout = null

const checkPartnerInterval = async () => {
  const {
    success,
    is_logged_in,
    data,
  } = await checkPartner()
  if (success && is_logged_in) {
    isLoggedIn.value = true
    creditLeft.value = data.credit
    usedCreditInBasket.value = data.credit - data.credit_left

    currentCheckTimeout = setTimeout(async () => {
      await checkPartnerInterval()
    }, 800)
  } else {
    isLoggedIn.value = false
    creditLeft.value = 0
    usedCreditInBasket.value = 0
  }
}

onMounted(async () => {
  await checkPartnerInterval()
})

onUnmounted(() => {
  if (currentCheckTimeout) {
    clearTimeout(currentCheckTimeout)
  }
})
</script>

<template>
  <teleport to="body">
    <div
      class="fixed right-0 bottom-0 text-6 text-white px-8 py-4 z-8"
      :class="usedCreditInBasket < creditLeft ? 'bg-green-500' : 'bg-red'"
      v-if="showNotification"
    >
      <div class="flex items-center lg:flex-col">
        <div class="mr-2 lg:mr-0">Krediit</div>
        <div class="font-bold lg:text-8">
          {{
            `${formatPrice(usedCreditInBasket)} ${currency}/${formatPrice(
              creditLeft
            )} ${currency}`
          }}
        </div>
      </div>
    </div>
  </teleport>
</template>
